import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../../_components/Navbar/Navbar";
import Footer from "../../_components/Footer";
import { CategorySelector } from "./components/CategorySelector";
import { PageSection } from "_components/PageSection";

export const GlossaryMain: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>
          LaborHack - Artisan Glossary | Professional Terms & Definitions
        </title>
        <meta
          name="description"
          content="Browse comprehensive glossaries for different artisan categories. Find definitions and explanations for professional terms used in plumbing, electrical, painting, and more."
        />
      </Helmet>

      <Navbar colorScheme="prussianBlue" />

      <div className="bg-[#FEFEFE] min-h-screen py-10">
        <PageSection>
          <CategorySelector />
        </PageSection>
      </div>

      <Footer />
    </>
  );
};
